import { useDispatch } from 'react-redux';

import { showAlertDialog, updateAlertDialog, useUnsavedDataAlertProps } from '../../reducers/unsavedDataAlertSlice';

interface UseUnsavedDataAlertProps {
  isUnsavedDataAlertDialogVisible: boolean;
  showUnsavedDataAlertDialog: (payload: ShowUnsavedDataAlertPayload) => void;
}
type ShowUnsavedDataAlertPayload = {
  isTriggerRequired?: boolean;
  triggeredText?: string;
  title?: string;
  description?: string;
  cancelText?: string;
  actionText?: string;
  onCancelCallback?: () => void;
  onActionCallback?: () => void;
};

const useUnsavedDataAlert = (): UseUnsavedDataAlertProps => {
  const dispatch = useDispatch();
  const { isUnsavedDataAlertDialogVisible } = useUnsavedDataAlertProps();

  const showUnsavedDataAlertDialog = ({
    triggeredText = 'Open',
    title = 'You have some unsaved changes',
    description = 'Before you proceed would you like to review & save the changes you have made?',
    cancelText = 'Discard & Proceed',
    actionText = 'Stay',
    isTriggerRequired = false,
    onCancelCallback = () => {},
    onActionCallback = () => {},
  }) => {
    const payload = {
      isTriggerRequired,
      triggeredText,
      title,
      description,
      cancelText,
      actionText,
      isUnsavedDataAlertDialogVisible: true,
      onCancel: onCancelCallback,
      onAction: onActionCallback,
      onOpenChange: (status: boolean) => {
        dispatch(updateAlertDialog({ isUnsavedDataAlertDialogVisible: status }));
      },
    };
    dispatch(showAlertDialog(payload));
  };

  return {
    isUnsavedDataAlertDialogVisible,
    showUnsavedDataAlertDialog,
  };
};

export default useUnsavedDataAlert;
